import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  followAccount,
  unfollowAccount,
  unblockAccount,
  unmuteAccount,
} from '../../actions/accounts'
import {
  addShortcut,
  removeShortcut,
} from '../../actions/shortcuts'
import { initReport } from '../../actions/reports'
import { openModal } from '../../actions/modal'
import {
  openPopover,
  closePopover,
} from '../../actions/popover'
import { POPOVER_SHARE, MODAL_COMPOSE } from '../../constants'
import { unfollowModal, me, isStaff } from '../../initial_state'
import { makeGetAccount } from '../../selectors'
import PopoverLayout from './popover_layout'
import List from '../list'

class ProfileOptionsPopover extends React.PureComponent {

  makeMenu() {
    const { account, isShortcut } = this.props;

    let menu = [];

    if (!account) return menu

    const isMyProfile = !account ? false : account.get('id') === me
    
    menu.push({
      hideArrow: true,
      icon: 'share',
      title: `Share @${account.get('acct')}'s profile`,
      onClick: this.handleShare,
    });

    if (!isMyProfile) {
      const isBlockedBy = account.getIn(['relationship', 'blocked_by'])
      if (!isBlockedBy) {
        menu.push({
          hideArrow: true,
          icon: 'comment',
          title: 'Mention',
          onClick: this.handleOnMention,
        });
      }
      
      if (account.getIn(['relationship', 'following'])) {
        const showingReblogs = account.getIn(['relationship', 'showing_reblogs'])
        menu.push({
          hideArrow: true,
          icon: 'repost',
          title: showingReblogs ? `Hide reposts from @${account.get('acct')}` : `Show reposts from @${account.get('acct')}`,
          onClick: this.handleRepostToggle,
        })
      }

      
      const isMuting = account.getIn(['relationship', 'muting'])
      menu.push({
        hideArrow: true,
        icon: 'audio-mute',
        title: isMuting ? `Unmute @${account.get('acct')}` : `Mute @${account.get('acct')}`,
        onClick: this.handleMute,
      })

      const isBlocking = account.getIn(['relationship', 'blocking'])
      menu.push({
        hideArrow: true,
        icon: 'block',
        title: isBlocking ? `Unblock @${account.get('acct')}` : `Block @${account.get('acct')}`,
        onClick: this.handleBlock,
      })

      menu.push({
        hideArrow: true,
        icon: 'error',
        title: `Report @${account.get('acct')}`,
        onClick: this.handleReport,
      })
      menu.push({
        hideArrow: true,
        icon: 'star',
        title: isShortcut ? `Remove from shortcuts` : `Add to shortcuts`,
        onClick: this.handleToggleShortcuts,
      })
    }

    // menu.push({
    //   hideArrow: true,
    //   icon: 'list',
    //   title: 'Add to list',
    //   onClick: this.handleAddToList
    // })

    if (isStaff) {
      menu.push({
        icon: 'ellipsis',
        title: `Open admin for @${account.get('acct')}`,
        href: `/admin/accounts/${account.get('id')}`,
        openInNewTab: true,
      })
    }

    if (isMyProfile) {
      menu.push({
        icon: 'search',
        title: 'Search my posts',
        href: '/settings/statuses',
        openInNewTab: true,
      });   
    }


    return menu
  }

  handleShare = () => {
    this.props.onShare(this.props.account)
  }

  handleFollow = () => {
    this.props.onFollow(this.props.account);
  }

  handleBlock = () => {
    this.props.onBlock(this.props.account);
  }

  handleOnMention = () => {
    this.props.onMention(this.props.account);
  }

  handleReport = () => {
    this.props.onReport(this.props.account);
  }

  handleRepostToggle = () => {
    this.props.onRepostToggle(this.props.account);
  }

  handleMute = () => {
    this.props.onMute(this.props.account);
  }

  handleAddToList = () => {
    this.props.onAddToList(this.props.account);
  }

  handleToggleShortcuts = () => {
    if (this.props.isShortcut) {
      this.props.onRemoveShortcut(this.props.account.get('id'))
    } else {
      this.props.onAddShortcut(this.props.account.get('id'))
    }
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { isXS } = this.props
    const listItems = this.makeMenu()

    return (
      <PopoverLayout
        width={250}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <List
          scrollKey='profile_options'
          items={listItems}
          size={isXS ? 'large' : 'small'}
        />
      </PopoverLayout>
    )
  }
}

const mapStateToProps = (state, { account }) => {
  const getAccount = makeGetAccount()
  const accountId = !!account ? account.get('id') : -1
  const shortcuts = state.getIn(['shortcuts', 'items'])
  const isShortcut = !!shortcuts.find((s) => {
    return s.get('shortcut_id') == accountId && s.get('shortcut_type') === 'account'
  })

  return {
    isShortcut,
    account: getAccount(state, accountId),
  }
}

const mapDispatchToProps = (dispatch, { innerRef }) => ({
  onFollow(account) {
    if (account.getIn(['relationship', 'following']) || account.getIn(['relationship', 'requested'])) {
      if (unfollowModal) {
        dispatch(openModal('UNFOLLOW', {
          account,
        }))
      } else {
        dispatch(unfollowAccount(account.get('id')))
      }
    } else {
      dispatch(followAccount(account.get('id')))
    }
  },
  onBlock(account) {
    dispatch(closePopover())
  
    if (account.getIn(['relationship', 'blocking'])) {
      dispatch(unblockAccount(account.get('id')));
    } else {
      dispatch(openModal('BLOCK_ACCOUNT', {
        accountId: account.get('id'),
      }));
    }
  },
  onMention(mentionAccount) {
    dispatch(closePopover())
    dispatch(openModal(MODAL_COMPOSE, { mentionAccount }))
  },
  onRepostToggle(account) {
    dispatch(closePopover())
    if (account.getIn(['relationship', 'showing_reblogs'])) {
      dispatch(followAccount(account.get('id'), false));
    } else {
      dispatch(followAccount(account.get('id'), true));
    }
  },
  onReport(account) {
    dispatch(closePopover())
    dispatch(initReport(account));
  },
  onMute(account) {
    dispatch(closePopover())
    if (account.getIn(['relationship', 'muting'])) {
      dispatch(unmuteAccount(account.get('id')));
    } else {
      dispatch(openModal('MUTE', {
        accountId: account.get('id'),
      }))
    }
  },
  onAddToList(account) {
    dispatch(closePopover())
    dispatch(openModal('LIST_ADD_USER', {
      accountId: account.get('id'),
    }));
  },
  onClosePopover: () => dispatch(closePopover()),
  onAddShortcut(accountId) {
    dispatch(closePopover())
    dispatch(addShortcut('account', accountId))
  },
  onRemoveShortcut(accountId) {
    dispatch(closePopover())
    dispatch(removeShortcut(null, 'account', accountId))
  },
  onShare(account) {
    dispatch(openPopover(POPOVER_SHARE, {
      innerRef,
      account,
      position: 'top',
    }))
  },
})

ProfileOptionsPopover.defaultProps = {
  isXS: PropTypes.bool,
  isShortcut: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileOptionsPopover)